import { useCallback } from 'react';
import { api } from 'services/api.service';

export default function useRequestPickupChange() {
  const requestChange = useCallback(
    (pickupUuid: string, notes: string) =>
      api.post(`/pickups/${pickupUuid}/request_change`, { notes }),
    []
  );

  return {
    requestChange,
  };
}
